<script type="text/javascript">
	import { createEventDispatcher } from "svelte"
	import { get } from "svelte/store"
	import LoadState from "../../Enums/LoadState";
	import MapStore from "../../Map/Store";

	export let charts = [];
	export let filterString = "";
	export let height = 300;

	let style = "height:"+height+"px;min-height:"+height+"px;";

	const dispatch = createEventDispatcher(); // update
</script>
<div class="hydrographic-charts-table-container mdc-elevation--z2">
	<table class='svelte-table'>
		<thead>
			<tr>
				<th>Name</th>
				<th width="60">Scale</th>
				<th width="60">Visible</th>
			</tr>
		</thead>
		<tbody>
			{#each charts as chart (chart.file)}
				{#if (filterString.trim().length === 0 ||
					chart.name.toLowerCase().indexOf(filterString.toLowerCase()) >= 0)}
					<tr>
						<td><a href="javascript:;" on:click={()=>{
							MapStore.helpers.zoomToLine(chart.bl, chart.tr);
						}}>{chart.name}</td>
						<td>{chart.scale}</td>
						<td>
							{#if get(chart.loadState) === LoadState.LOADING}
								Loading...
							{:else}
								<button
									class={(get(chart.visible)?"bg-primary":"bg-info")}
									style="font-size:12px;"
									on:click={()=>{
										chart.visible.set(!get(chart.visible));
										dispatch("update");
									}}
									>{get(chart.visible)}</button>
							{/if}
						</td>
					</tr>
				{/if}
			{/each}
		</tbody>
	</table>
</div>
